var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalHealthManufacturingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#0066CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6917 11.8166C20.4745 11.7175 20.2387 11.6663 20 11.6663C19.7614 11.6663 19.5255 11.7175 19.3083 11.8166L12.1667 15.0666C12.0188 15.1318 11.8931 15.2386 11.8048 15.3739C11.7165 15.5093 11.6696 15.6674 11.6696 15.8291C11.6696 15.9907 11.7165 16.1488 11.8048 16.2842C11.8931 16.4196 12.0188 16.5264 12.1667 16.5916L19.3167 19.8499C19.5338 19.9489 19.7697 20.0002 20.0083 20.0002C20.247 20.0002 20.4829 19.9489 20.7 19.8499L27.85 16.5999C27.9979 16.5347 28.1236 16.4279 28.2119 16.2925C28.3001 16.1571 28.3471 15.999 28.3471 15.8374C28.3471 15.6758 28.3001 15.5177 28.2119 15.3823C28.1236 15.2469 27.9979 15.1401 27.85 15.0749L20.6917 11.8166Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 20C11.6662 20.1594 11.7116 20.3155 11.7972 20.45C11.8829 20.5844 12.0053 20.6914 12.15 20.7583L19.3166 24.0167C19.5326 24.1145 19.767 24.1651 20.0041 24.1651C20.2412 24.1651 20.4756 24.1145 20.6916 24.0167L27.8416 20.7667C27.9891 20.7004 28.1142 20.5926 28.2015 20.4564C28.2888 20.3203 28.3346 20.1617 28.3333 20",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 24.1667C11.6662 24.3261 11.7116 24.4823 11.7972 24.6167C11.8829 24.7511 12.0053 24.8581 12.15 24.9251L19.3166 28.1834C19.5326 28.2812 19.767 28.3318 20.0041 28.3318C20.2412 28.3318 20.4756 28.2812 20.6916 28.1834L27.8416 24.9334C27.9891 24.8671 28.1142 24.7593 28.2015 24.6232C28.2888 24.4871 28.3346 24.3285 28.3333 24.1667",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalHealthManufacturingIcon);
export default __webpack_public_path__ + "static/media/Animal Health Manufacturing-icon.24fd3d1a84fdca7003625ec829423ac1.svg";
export { ForwardRef as ReactComponent };